<template>
  <div>
    <div class="container-alb filter-mobile">
      <table
        cellpadding="10"
        cellspacing="0"
        width="95%"
        class="hover-table"
        align="center"
      >
                  <tr>
              <td align="left">
                <small>{{ $t("lastNameField") }}</small>
                <br />
                <input
                  type="text"
                  v-model="formData.name"
                  class="formedituser"
                  @keyup="updateInputCharacters()"
                />
              </td>

              <td align="left">
                <small>{{ $t("fiscalCodeLabel") }}</small>
                <br />
                <input
                  type="text"
                  v-model="formData.fiscal"
                  class="formedituser"
                  @keyup="updateInputCharacters()"
                />
              </td>
              <!-- <td align="left" colspan="2">
                <small>{{ $t("logoUrlLabel") }}</small>
                <br />
                <input
                  type="text"
                  v-model="formData.logoUrl"
                  class="formedituser"
                  @keyup="updateInputCharacters()"
                />
              </td> -->
            </tr>
            <tr>
              <td align="left" >
                <small>{{ $t("descriptionRoLabel") }}</small>
                <br />
                <input
                  type="text"
                  v-model="formData.summary.ro"
                  class="formedituser"
                  @keyup="updateInputCharacters()"
                />
              </td>
              <td align="left">
                <small>{{ $t("descriptionEnLabel") }}</small>
                <br />
                <input
                  type="text"
                  v-model="formData.summary.en"
                  class="formedituser"
                  @keyup="updateInputCharacters()"
                />
              </td>
            </tr>
            <tr>
              <td>
                <a
                  class="notification-action"
                  @click="submitnewPartnerDetails()"
                  >{{ $t("orderAddNewRowButtonLabel") }}</a
                >
              </td>
            </tr>

      </table>
    </div>

    <!-- card transaction -->
    <div class="container-alb">
      <!-- adauga partener -->
                 <table width="95%" align="center" cellpadding="10" cellspacing="0">

            <!-- <tr>
              <td align="left">
                <small>{{ $t("mobileField") }}</small>
                <br />
                <input
                  type="text"
                  id="beneficiaryMobilePhone"
                  v-model="formData.mobilePhone"
                  class="formedituser"
                  disabled
                  @keyup="updateInputCharacters()"
                />
              </td>
              <td align="left">
                <small>{{ $t("emailField") }}</small>
                <br />
                <input
                  type="text"
                  id="beneficiaryEmail"
                  v-model="formData.email"
                  class="formedituser"
                  disabled
                />
              </td>
            </tr> -->
          </table>
      <br />

      <!-- partners table -->
      <div>
    <table
      cellpadding="10"
      cellspacing="0"
      width="95%"
      class="hover-table invoices-table"
      align="center"
    >
      <thead>
        <tr>
          <td valign="middle">
            <strong>{{ $t("lastNameLabel") }}</strong>
          </td>
                    <td valign="middle">
            <strong>{{ $t("fiscalCodeLabel") }}</strong>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr v-if="this.partnersList === null">
          <td colspan="6">
            <div class="loading">
              <img src="@/assets/images/loading.gif" />
            </div>
          </td>
        </tr>
        <template v-for="(partner, index) in partnersList">
          <tr
            :key="index"
            class="trhover parent"
            :class="index % 2 === 0 && 'gri-cell'"
          >
            <td valign="middle">
              {{ partner.name }}
            </td>
             <td valign="middle">
              {{ partner.fiscal }}
            </td>
          </tr>
        </template>
      </tbody>
    </table>
      </div>

      <div
        class="error-wrapper border-box"
        v-if="this.partnersList && this.partnersList.length === 0"
      >
        <p>{{ $t("noBeneficiariesInfoMessage") }}</p>
      </div>

    </div>
    <div id="modal_popup_info" class="modal-popup">
      <div class="modal-popup-content">
        <a
          @click="showModalPopup('modal_popup_info', false)"
          class="close-button"
        >
          <img src="@/assets/images/close-button.svg" />
        </a>
        <div v-if="this.error">
          <!-- <p v-html="$t('commercialError_' + this.error.code)"></p> -->
          <p >{{this.error.description}}</p>
        </div>
         <div v-else>
          <!-- <p v-html="$t('commercialError_' + this.error.code)"></p> -->
        <p v-html="$t('partnerAddSuccess')"></p>
        </div>
      </div>
    </div>
    <div id="modal_popup_loading" class="modal-popup">
      <div class="modal-popup-content">
        <img src="@/assets/images/loading.gif" />
        <p v-html="$t('loadingPopupMessage')"></p>
      </div>
    </div>
  </div>
</template>

<script>
  import httpServiceCommercial from "@/http/http-commercial.js";
  import Cookies from "js-cookie";
  import validator from "@/plugins/fieldValidation.js";

  export default {
    props: {
      msg: String,
    },
    components: {
    },
    data() {
      return {
        partnersList: [],
        error: null,
        config: JSON.parse(sessionStorage.getItem("client_jsonFile")),
        formData: {
          name: "",
          logoUrl: "",
          fiscal: "",
          summary: {
            ro: "",
            en: ""
          }
        },
        // cardProducts: [
        //   {
        //     brand: "dejun",
        //     card: 11,
        //     name: "Up Dejun",
        //     order: 1,
        //     paper: 0,
        //     perso: true,
        //   },
        //   {
        //     brand: "cadou",
        //     card: 13,
        //     name: "Up Cadou",
        //     order: 2,
        //     paper: 0,
        //     perso: true,
        //   },
        // ],
      };
    },
    methods: {
      productSelected(event) {
        this.filters.product = event.target.value;
        this.getPartners();
      },
      isSelectedProduct(product) {
        return product === this.filters.product;
      },
      sortBy(sortField, sortDirection, status) {
        this.sortField = sortField;
        this.sortDirection = sortDirection;
        this.getPartners(status);
      },
      showModalPopup(elementId, show) {
        if (show) {
          document.getElementById(elementId).style.visibility = "visible";
        } else {
          document.getElementById(elementId).style.visibility = "hidden";
        }
      },
      getPartners() {
        this.error = null;
        this.showModalPopup("modal_popup_loading", true);

        httpServiceCommercial.customerService
          .getPartners(Cookies.get("token"))
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            return error.response;
          })
          .then((response) => {

            if (response.status == 200) {
              this.partnersList = response.data;
            } else if (response.status == 400) {
              this.error = { code: response.data.error_code };
            } else {
              this.error = { code: response.error_code };
            }
            if (this.error) {

              this.showModalPopup("modal_popup_info", true);
            }
            this.showModalPopup("modal_popup_loading", false);
          })

      },
      submitnewPartnerDetails() {
        this.showModalPopup("modal_popup_loading", true);
        this.actionError = null;
        httpServiceCommercial.customerService
          .addPartner(
            {
              name: this.formData.name,
              fiscal: this.formData.fiscal,
              url_log: this.formData.logoUrl,
              i18: [{ language: "ro", summary: this.formData.summary.ro },
              { language: "en", summary: this.formData.summary.en }
              ]
            },
            Cookies.get("token")
          )
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            return error.response;
          })
          .then((response) => {
            if (response.status == 200) {
              this.actionSuccess = true;
              this.getPartners();
              // window.location.reload();
            } else if (response.status == 400) {
              this.error = response.data;
            } else {
              this.error = response.data
            }

            this.showModalPopup("modal_popup_loading", false);
            this.showModalPopup("modal_popup_info", true);
          });
      },
      selectProduct(index) {
        this.selectedProduct = this.cardProducts[index];
      },
      updateInputCharacters() {
        this.formData.lastName = this.onlyAlphabetCharacters(
          this.formData.lastName
        );
        this.formData.firstName = this.onlyAlphabetCharacters(
          this.formData.firstName
        );
        this.formData.mobilePhone = this.onlyNumericCharacters(
          this.formData.mobilePhone
        );
        this.beneficiary.security_code = this.onlyNumericCharacters(
          this.beneficiary.security_code
        );
        this.$forceUpdate();
      },
    },
    mounted() {
      this.getPartners();
    },
    created() {
    },
    watch: {
      currentPage: function () {
        this.getPartners();
      },
    },
  };
</script>

<style scoped src="@/assets/styles/beneficiary.css"></style>
<style>
  .page-link {
    color: #4a4a4a;
  }

  .page-link:hover {
    color: #4e5b59;
  }

  .page-item.active .page-link {
    background-color: #4e5b59 !important;
    border-color: #4e5b59 !important;
  }

  .invoices-filter .reportrange-text {
    height: 27px;
    font-size: 13px;
    padding: 3px 10px;
    border: none !important;
    color: #585858;
    background: #f1f1f1;
  }
</style>
